import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { InputFieldType } from '../../enums/InputFieldType';
import DynamicFormFieldDTO from '../../dtos/DynamicFormFieldDTO';
import OnFieldChangeDTO from '../../dtos/OnFieldChangeDTO';
import { UtilitiesService } from 'src/app/common/services/utilities.service';
import { LoggerService } from 'src/app/common/services/logger.service';
import { DynamicFormV2Component } from '../../dynamic-form-v2.component';
import { BaseInputValidationServiceService } from 'src/app/common/services/base-input-validation-service.service';
import { MessageService } from 'primeng/api';
import { DateTime } from 'luxon';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';
import debounce from 'lodash/debounce';
import { OfficeTimeFormPipe } from 'src/app/common/pipes/officeTimeForm.pipe';

@Component({
  selector: 'app-base-input-field',
  templateUrl: './base-input-field.component.html',
  styleUrls: ['./base-input-field.component.sass'],
  providers: [MessageService],
})
export class BaseInputFieldComponent2 implements OnInit, AfterViewInit {
  @Input() record: any; // Define a more specific type if possible
  @Input() label: string;
  @Input() onLabel: string;
  @Input() offLabel: string;
  @Input() inputType: string;
  @Input() inputTypeFields: InputFieldType[];
  @Input() field: DynamicFormFieldDTO;
  @Input() options: Array<any>; // Accept options as input
  @Input() fieldValue: any; // Assuming the type is any; specify the correct type
  @Input() entityType: string;

  // @Input() style: any; // Assuming the type is any; specify the correct type

  @Input() optionLabel: string;
  @Input() optionValue: string;
  @Input() optionDisabled: string;
  @Output() fieldChanged = new EventEmitter<OnFieldChangeDTO>();
  @Input() validate: (value: string) => boolean;
  @Input() isdisplayNameIDPath: boolean = false;
  @Input() isEdit: boolean;
  @Output() isBaseInputValid = new EventEmitter<boolean>();
  @Output() fieldValueChange = new EventEmitter<any>();
  @Input() dynamicForm: DynamicFormV2Component;
  @Input() showQueryDropdown: boolean = false;

  repeats: string[] = []; // This is the array stored in the database

  touchedCosts: boolean = false;

  isDialogVisible: boolean = false;
  selectedItems: any[] = [];
  reorderExpanded: boolean = false;

  private debounceHandleDateInputChange: (field: any, event: any) => void;
  defaultDate: any;

  InputFieldType = InputFieldType;
  specificObject: any;
  suggestions: Array<any> = [];

  @Input() useServiceFunctions: boolean = false;
  @Input() listboxFilterValue: string = '';
  @Output() listboxFilterValueChange = new EventEmitter<string>();
  @Input() listboxScrollTop: number = 0;
  @Output() listboxScrollTopChange = new EventEmitter<number>();
  @ViewChild('listboxEl') listboxEl: any;


  fieldTemplates: {
    [key: string]: {
      header?: string[];
      fields: string[];
    };
  } = {
      'Link - Destination': {
        header: ['Link', 'Destination'],
        fields: ['linkText', 'linkDestination'],
      },
      'Target Collection': {
        fields: ['name', 'id'],
      },
    };

  get isValid(): boolean {
    return this.field.validate
      ? this.field.validate(this.fieldValueChange)
      : true;
  }

  constructor(
    private utilitiesService: UtilitiesService,
    private loggerService: LoggerService,
    private validationService: BaseInputValidationServiceService,
    private messageService: MessageService,
    private commonEntityService: CommonEntityService,
    private officeTimePipe: OfficeTimeFormPipe,
  ) {
    this.debounceHandleDateInputChange = debounce(this.handleDateInputChange, 3000).bind(this);
  }

  ngOnInit() {
    //
    if (this.field.showField === undefined) {
      this.field.showField = true;
    }
    //
    if (
      !this.fieldValue &&
      (this.inputTypeFields.includes(InputFieldType.MultiSelect) ||
        this.inputTypeFields.includes(InputFieldType.MultiTextInput) ||
        (this.inputTypeFields.includes(InputFieldType.AutoComplete) && this.field?.autocompleteMultipleValues))
    ) {
      this.fieldValue = [];
    }
    if (
      this.fieldValue &&
      this.inputTypeFields.includes(InputFieldType.Dropdown)
    ) {
      this.loggerService.log('fieldValue', this.fieldValue);
      // this.fieldValue = this.options.map(item => item._id)
      if (this.fieldValue._id) {
        this.fieldValue = this.fieldValue._id;
      }
      // Handle case where fieldValue is a number but options use _id as value
      // This happens when editing records that store type numbers but dropdown uses template _id
      else if (typeof this.fieldValue === 'number' && this.options && this.field?.key) {
        // Defer the conversion to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          const fieldKey = String(this.field.key);
          const options = (this.options as any)[fieldKey];
          if (Array.isArray(options)) {
            const optionValue = this.field.optionValue || 'value';
            // Try to find an option that matches by checking if any option has a type property matching the number
            // This is a fallback for cases like rewards-track where type number needs to match template _id
            const matchingOption = options.find((opt: any) => {
              // Check if option has a type property that matches our numeric fieldValue
              return opt.type === this.fieldValue;
            });
          if (matchingOption && matchingOption[optionValue]) {
            // Store the original numeric type for components that need it (e.g., rewards-track-input)
            const originalNumericType = this.fieldValue;
            
            // Convert the numeric value to the option's value (e.g., template _id)
            this.fieldValue = matchingOption[optionValue];
            // Update the record to reflect this change
            if (this.record && this.field?.key) {
              (this.record as any)[this.field.key] = matchingOption[optionValue];
              // Store the original numeric type so other components can access it
              (this.record as any).__originalType = originalNumericType;
            }
          }
          }
        }, 0);
      }
    }
    if (
      this.fieldValue &&
      this.inputTypeFields.includes(InputFieldType.Calendar)
    ) {
      this.fieldValue = this.fieldValue ? new Date(this.officeTimePipe.transform(this.fieldValue)) : null
    }
    if (
      !this.fieldValue &&
      this.inputTypeFields.includes(InputFieldType.Calendar)
    ) {
      this.defaultDate = this.utilitiesService.getCurrentDateAtMidnight();
    }

    // trigger value change to let neighboring components know the initial value
    if (this.field.emitOnInit) {
      this.emitFieldValueChange(this.fieldValue);
    }

    if (this.field) {
      if (this.field.inputTypeFields.includes(InputFieldType.Dropdown) &&
        (this.field.type === 'ref' || this.field.type === 'self')) {
        this.loadOptions(this.field);
      }
    }

    if (this.isEdit && this.field.inputTypeFields.includes(InputFieldType.AutoComplete) && this.field?.suggestions?.initializeWith_id) {
      this.initializeWithID();
    }
  }

  ngAfterViewInit() {
    if (!this.listboxEl) return;
    const wrapper = this.listboxEl.el?.nativeElement?.querySelector('.p-listbox-list-wrapper');
    if (!wrapper) return;

    if (this.listboxScrollTop) {
      wrapper.scrollTop = this.listboxScrollTop;
    }

    wrapper.addEventListener('scroll', () => {
      this.listboxScrollTopChange.emit(wrapper.scrollTop);
    });
  }

  onValueChange(newValue: any) {
    let isValid = true;
    let errorMessage = '';

    // Validate the field if validation function is present
    if (this.field.validate) {
      const validationResult = this.field.validate(newValue, this.record, this.field.key);

      if (Array.isArray(validationResult)) {
        [isValid, errorMessage] = validationResult;
      } else if (typeof validationResult === 'boolean') {
        isValid = validationResult;
      }
    }

    this.field.touched = true;

    // Handle null value (clearing the field)
    if (newValue === null) {
      this.clearFieldValue(newValue);
      return;
    }

    // Update and emit logic
    if (isValid) {
      this.fieldValue = newValue; // Update with the new value
    } else {
      this.fieldValue = null; // Optionally reset the invalid input
      this.showErrorMessage('Invalid Input', errorMessage);
    }

    this.emitFieldValueChange(this.fieldValue);
    this.emitIsBaseInputValid(isValid);
  }

  addOneMultiTextInput() {
    this.fieldValue.push(null);
  }

  deleteOneMultiTextInput(index: number) {
    this.fieldValue = this.fieldValue.filter((_: string, tmpIndex: number) => tmpIndex != index);
  }

  onMultiTextInputValueChange(index: number, value: string) {
    let isValid = true;
    let errorMessage = '';

    // Validate the field if validation function is present
    if (this.field.validate) {
      const validationResult = this.field.validate(value, this.record, this.field.key);

      if (Array.isArray(validationResult)) {
        [isValid, errorMessage] = validationResult;
      } else if (typeof validationResult === 'boolean') {
        isValid = validationResult;
      }
    }

    // Update and emit logic
    if (isValid) {
      this.fieldValue[index] = value; // Update with the new value
    } else {
      this.fieldValue[index] = null; // Optionally reset the invalid input
      this.showErrorMessage('Invalid Input', errorMessage);
    }

    this.emitFieldValueChange(this.fieldValue);
    this.emitIsBaseInputValid(isValid);
  }

  onPrizeChange(value: any[]) {
    this.fieldValue = value;
    this.touchedCosts = true
    this.emitFieldValueChange(this.fieldValue);
  }

  trackByIndexMultiTextInput(index: number): number {
    return index;
  }

  // Helper function to clear the field value and emit changes
  private clearFieldValue(newValue: any) {
    this.fieldValue = null; // Reset the internal fieldValue
    this.fieldValueChange.emit(newValue); // Emit the change
  }

  // Helper function to emit field value change
  private emitFieldValueChange(value: any) {
    const normalizeValue = (input: any) => {
      if (this.field.inputTypeFields[0] === 'Calendar') {
        return new Date(input).getTime(); // Convert date to Unix timestamp
      }
      return input; // Return as-is for non-date values
    };

    const recordValue = normalizeValue(this.record[this.field.key]);
    const newValue = normalizeValue(value);

    if (recordValue != newValue) {
      console.log('TOUCHING: ', this.field.key);
      this.field.touched = true;
    }

    this.fieldValueChange.emit(value); // Emit the updated fieldValue
  }

  // Method to emit a boolean to the parent component to indicate if the input is valid
  emitIsBaseInputValid(isValid: boolean) {
    this.isBaseInputValid.emit(isValid);
  }

  // this function is used to show the error message for validation set within the parent form component and onValueChange function
  showErrorMessage(summary: string, detail: string) {
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      // life: 3000, // Message duration in milliseconds
    });
  }

  // Additional method if needed for p-multiSelect specific logic
  onMultiSelectChange(event: any) {
    // Update the record value based on the multiSelect change
    this.record[this.field.key] = event.value;
    // Call onValueChange to handle the change
    this.onValueChange(event.value);
  }

  handleDateInputChange(field: any, event: any) {
    const inputValue = event.target.value;
    // Adjust the format to include time (e.g., 'yyyy-MM-dd HH:mm')
    const isValidDateTime = DateTime.fromFormat(
      inputValue,
      'yyyy-MM-dd HH:mm'
    ).isValid;

    if (isValidDateTime) {
      const parsedDate = DateTime.fromFormat(inputValue, 'yyyy-MM-dd HH:mm').toJSDate();
      if (field === 'start') {
        this.record.start = parsedDate;
      } else if (field === 'end') {
        this.record.end = parsedDate;
      }
      // Additional code to handle valid date
    } else {
      this.showErrorMessage('Invalid Date Input', 'Please enter a valid date. A valid format should be YYYY-MM-DD HH:mm.');
    }
  }

  onDateInputChange(field: any, event: any) {
    this.debounceHandleDateInputChange(field, event);
  }

  resetTime() {
    if (this.fieldValue) {
      // Set the time part of the date to 00:00
      this.fieldValue.setHours(0, 0, 0, 0);

      // Update the model to ensure changes are reflected in the view
      this.fieldValue = new Date(this.fieldValue);

      // Call onValueChange or similar method to handle any side effects of changing the date
      this.onValueChange(this.fieldValue);
    }
  }

  clearField(key: string): void {
    this.record[key] = null;
    this.field.touched = true; // Mark the field as touched
    this.onValueChange(null); // Trigger validation and update logic
  }

  /**
   * Text for an object option when the field sets no `labelKeys`: its `optionLabel` property, else
   * the usual name/label/value. The multi-select templates used to print nothing in that case, so
   * e.g. the v3 Item form's Environment(s) options were blank rows (CMS-6338).
   */
  optionText(option: any): string {
    if (!this.isObject(option)) {
      return option ?? '';
    }
    const label = this.field?.optionLabel ? option[this.field.optionLabel] : undefined;
    return label ?? option.name ?? option.label ?? option.value ?? '';
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  /**
   * Finds the full option object from the options array based on the selected value.
   * Used when optionValue is set and we need to display the full label for selected items.
   */
  getOptionByValue(value: any, fieldKey: string, optionValueKey: string): any {
    if (!this.options || !(this.options as any)[fieldKey] || !optionValueKey) {
      return null;
    }
    return (this.options as any)[fieldKey].find((opt: any) => opt[optionValueKey] === value);
  }

  // Drag and drop for multiselect reordering
  private multiselectDragIndex: number = -1;

  onMultiselectDragStart(index: number): void {
    this.multiselectDragIndex = index;
  }

  onMultiselectDrop(dropIndex: number): void {
    if (this.multiselectDragIndex >= 0 && this.multiselectDragIndex !== dropIndex) {
      const draggedItem = this.fieldValue[this.multiselectDragIndex];
      const newArray = [...this.fieldValue];
      newArray.splice(this.multiselectDragIndex, 1);
      newArray.splice(dropIndex, 0, draggedItem);
      this.fieldValue = newArray;
      this.onValueChange(this.fieldValue);
    }
    this.multiselectDragIndex = -1;
  }

  removeMultiselectItem(index: number): void {
    const newArray = [...this.fieldValue];
    newArray.splice(index, 1);
    this.fieldValue = newArray;
    this.onValueChange(this.fieldValue);
  }

  handleItemsRefChange(eventData: any) {
    console.log("Table input event received:", eventData);
    
    // Check if eventData has a type property (for structured events)
    if (eventData && eventData.type) {
      const fieldKey = this.field.key;
      
      switch (eventData.type) {
        case 'environment_change':
          this.record.env = eventData.value;
          this.field.touched = true;
          this.dynamicForm.onFieldValueChange('env', eventData.value);
          this.fieldValueChange.emit(eventData.value);
          this.dynamicForm.onRecordChange.emit(this.record);
          break;
          
        case 'enabled_change':
          this.record.enabled = eventData.value;
          this.field.touched = true;
          this.dynamicForm.onFieldValueChange('enabled', eventData.value);
          this.fieldValueChange.emit(eventData.value);
          this.dynamicForm.onRecordChange.emit(this.record);
          break;
          
        case 'item_edited':
          this.record[fieldKey] = eventData.value;
          this.field.touched = true;
          this.dynamicForm.onFieldValueChange(fieldKey, eventData.value);
          this.fieldValueChange.emit(eventData.value);
          this.dynamicForm.onRecordChange.emit(this.record);
          console.log(`Item edited in field ${fieldKey}:`, eventData.editedItem);
          break;
          
        case 'row_edited':
          this.record[fieldKey] = eventData.value;
          this.field.touched = true;
          this.dynamicForm.onFieldValueChange(fieldKey, eventData.value);
          this.fieldValueChange.emit(eventData.value);
          this.dynamicForm.onRecordChange.emit(this.record);
          console.log(`Row edited in field ${fieldKey}:`, eventData.editedItem);
          break;
          
        default:
          console.warn('Unhandled event type:', eventData.type);
          break;
      }
    }
    // Handle array data (items_ref changes)
    else if (Array.isArray(eventData)) {
      const strippedItemsRef = eventData.map((item: any) => ({
        id: item.id,
        _id: item._id,
        name: item.name
      }));

      console.log("Updated items_ref:", strippedItemsRef);
      
      this.record[this.field.key] = strippedItemsRef;
      this.fieldValue = strippedItemsRef;
      this.field.touched = true;
      
      this.dynamicForm.onFieldValueChange(this.field.key, strippedItemsRef, true);
      this.fieldValueChange.emit(strippedItemsRef);
      this.dynamicForm.onRecordChange.emit(this.record);
    }
    else {
      console.warn('Unknown event data format:', eventData);
    }
  }

  /**
     * Autocomplete searching
     *
     * @param value Query value
     * @param fieldName Field name
     * @param model API Controller
     * @param minimal Flag that sets whether or not to return minimal result
     * @param autopopulate Flag that sets whether or not to autopopulate result.
     * @param sort Sort expression
     * @param virtuals Flag that sets whether or not to include virtual props.
     * @param select Select query
     */
  async getSuggestionsForRef(
    value: any,
    fieldName: string | any,
    model: string,
    minimal: boolean = false,
    autopopulate: boolean = false,
    sort: any = null,
    virtuals: boolean = false,
    select: string | null = null,
    customQuery: any = null,
    customQueryField: string | null = null,
    isMiscAsset: boolean = false
  ) {
    if (!model) {
      this.suggestions[fieldName] = [];
      return;
    }

    try {
      let queryValue;

      // Handle empty value - show all items matching customQuery (if any)
      const isEmptyValue = !value || value === '';
      
      if (isEmptyValue) {
        // If there's a customQuery (like entityType filter), use it to show filtered results
        if (customQuery) {
          queryValue = customQuery;
        } else {
          // No customQuery and empty value - return empty suggestions
          this.suggestions[fieldName] = [];
          return;
        }
      } else if (isMiscAsset === true) {
        let idValue = parseInt(value);
        if (!isNaN(idValue)) {
          // id is a globally unique auto-increment field on MiscellaneousBuild, so it
          // already unambiguously identifies a record - the type-narrowing customQuery
          // (meant for name/path regex search) must not be ANDed in here or a correctly
          // known ID becomes unselectable whenever its assetType wasn't tagged for this field.
          queryValue = { id: idValue };
        } else {
          // For misc assets, search both name and path with regex
          queryValue = customQuery ? {
            ...customQuery,
            $or: [
              { name: { $regex: value, $options: 'i' } },
              { path: { $regex: value, $options: 'i' } }
            ]
          } : {
            $or: [
              { name: { $regex: value, $options: 'i' } },
              { path: { $regex: value, $options: 'i' } }
            ]
          };
        }
      } else {
        let idValue = parseInt(value);
        queryValue = customQuery ? customQuery : (
          customQueryField && customQueryField.length > 0
            ? (isNaN(idValue) ? { [customQueryField]: { $regex: value, $options: 'i' } } : { id: idValue })
            : (isNaN(idValue) ? { name: { $regex: value, $options: 'i' } } : { id: idValue })
        );
      }

      let result = await this.commonEntityService.findAllWithQuery(model, {
        query: queryValue,
        select: select ? select : '_id name id path',
        virtuals: virtuals,
        autopopulate: autopopulate,
        sort: sort ? sort : { name: 1 },
        isOptions: true,
        limit: 50 // Limit results to prevent performance issues
      });

      if (minimal) {
        let o: any[] = [];
        for (const option of result) {
          o.push({
            id: option.id,
            name: option.name,
            _id: option._id,
            path: option.path
          });
        }
        this.suggestions[fieldName] = o;
      } else {
        this.suggestions[fieldName] = result;
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      this.suggestions[fieldName] = [];
    }
  }

  async loadOptions(field: any) {
    if (!field || !field.relationshipEntity) {
      return;
    }
    try {
      const result = await this.commonEntityService.findAllWithQuery(field.relationshipEntity, {
        query: {},
        select: field.select ? field.select : '_id name id path',
        virtuals: field.virtuals,
        autopopulate: field.autopopulate,
        sort: field.sort ? field.sort : { name: 1 },
        isOptions: true
      });

      if (field.minimal) {
        let o: any[] = [];
        for (const option of result) {
          o.push({
            id: option.id,
            name: option.name,
            _id: option._id,
            path: option.path
          });
        }
        this.options[field.key] = o;
      } else {
        this.options[field.key] = result;
      }
    } catch (error) {
      console.error('Error loading options:', error);
      this.options[field.key] = [];
    }
  }

  transform(i: any) {
    const obj = this.options.find((item: any) => item._id === i);
    return obj ? obj.name + ' (' + obj.id + ')' : null;
  }

  /**
   * Gets options with _searchLabel computed from filterBy fields.
   * PrimeNG 16 ignores filterBy and ONLY filters by optionLabel,
   * so we create a combined search field and use it as optionLabel.
   */
  getOptionsForMultiFieldFilter(): any[] {
    const optionsObj = this.options as any;
    const rawOptions = optionsObj[this.field.key];
    
    if (!rawOptions || !Array.isArray(rawOptions)) {
      return [];
    }
    
    // If no multi-field filterBy, return options as-is
    if (!this.field.filterBy?.includes(',')) {
      return rawOptions;
    }
    
    // Check cache to avoid reprocessing
    if (this._optionsCache?.source === rawOptions && this._optionsCache?.filterBy === this.field.filterBy) {
      return this._optionsCache.processed;
    }
    
    // Build _searchLabel from the filterBy fields
    const filterFields = this.field.filterBy.split(',').map((f: string) => f.trim());
    
    const processed = rawOptions.map((opt: any) => {
      const labelParts = filterFields
        .map((field: string) => opt[field] != null ? String(opt[field]) : '')
        .filter((v: string) => v.length > 0);
      return {
        ...opt,
        _searchLabel: labelParts.join(' | ')
      };
    });
    
    this._optionsCache = { source: rawOptions, filterBy: this.field.filterBy, processed };
    return processed;
  }
  
  private _optionsCache: { source: any[], filterBy: string, processed: any[] } | null = null;

  propagateItems_refChange(value: any) {
    this.fieldValue = value;
  }

  // This method checks if the day is already selected in fieldValue
  isDaySelected(dayValue: string): boolean {
    return this.fieldValue && this.fieldValue.includes(dayValue);
  }

  // This method adds or removes the selected day from the fieldValue array
  toggleDaySelection(dayValue: string) {
    if (!this.fieldValue) {
      this.fieldValue = [];
    }

    if (this.fieldValue.includes(dayValue)) {
      // If the day is already selected, remove it from the array
      this.fieldValue = this.fieldValue.filter((day: string) => day !== dayValue);
    } else {
      // If the day is not selected, add it to the array
      this.fieldValue.push(dayValue);
    }

    this.emitFieldValueChange(this.fieldValue); // Emit changes
  }

  showSelectedItems() {
    if (this.options && typeof this.options === 'object' && this.field && typeof this.field.key === 'string') {
      const selectedOptions = this.options[this.field.key as keyof typeof this.options];

      if (Array.isArray(selectedOptions)) {
        // Handle simple string array options
        if (typeof selectedOptions[0] === 'string') {
          this.selectedItems = this.fieldValue.map((value: string) => ({
            name: value,
            link: null
          }));
        } 
        // Handle object-based options
        else if (this.field.optionValue) {
          this.selectedItems = selectedOptions
            .filter(option => this.fieldValue.includes(option[this.field.optionValue as keyof typeof option]))
            .map(option => ({
              ...option,
              link: `/${this.field.options?.apiController ?? ''}/${option['id'] ?? ''}`
            }));
        }
      } else {
        console.error("Selected options are not in an array format.");
        this.selectedItems = [];
      }

      this.isDialogVisible = true;
    } else {
      console.error("Options or field properties are not defined or improperly typed.");
    }
  }

  // initalizeWithID
  /**
   * 1. extract the _id from the record 
   * 2. Lookup for the record from the suggestions
   * 3. Replace the _id with the looked up record
   */
  async initializeWithID() {
    const value = this.record[this.field.key];
    if (!value) {
      return;
    }

    // Handle arrays of ObjectIds (for multiple AutoComplete fields)
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      if (typeof value[0] !== 'string') return; // already full objects
      // Array of _id strings — fetch full objects
      const query = { _id: { $in: value } };
      let result = await this.commonEntityService.findAllWithQuery(this.field?.suggestions?.apiController || '', {
        query: query,
        select: this.field?.suggestions?.select || 'id _id name',
        virtuals: this.field?.suggestions?.virtuals ?? false,
        autopopulate: false,
        sort: { name: 1 },
        isOptions: true
      });
      this.record[this.field.key] = result || [];
      return;
    }

    // Already a populated single object — wrap in array for multiple fields
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      this.record[this.field.key] = this.field?.autocompleteMultipleValues ? [value] : value;
      return;
    }

    // Single _id string — fetch full object
    const query = { _id: value };
    let result = await this.commonEntityService.findAllWithQuery(this.field?.suggestions?.apiController || '', {
      query: query,
      select: this.field?.suggestions?.select || 'id _id name',
      virtuals: this.field?.suggestions?.virtuals ?? false,
      autopopulate: false,
      sort: { name: 1 },
      isOptions: true
    });
    if (this.field?.autocompleteMultipleValues) {
      this.record[this.field.key] = result?.length ? [result[0]] : [];
    } else {
      this.record[this.field.key] = result?.length ? result[0] : null;
    }
  }

  /**
   * Prevents space key event propagation in autocomplete and input fields
   * This fixes the issue where space key is intercepted by PrimeNG components
   * @param event - The keyboard event
   */
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === ' ' || event.code === 'Space') {
      event.stopPropagation();
    }
  }
}
